import { defineAsyncComponent } from 'vue'
export default {
  checkout: defineAsyncComponent(() => import("/opt/teamcity/buildAgent/work/984757540e73c1d/app/layouts/checkout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/teamcity/buildAgent/work/984757540e73c1d/app/layouts/default.vue").then(m => m.default || m))
}